import React from "react";
import { Button } from "@mui/material";

const ACTION_BUTTON_SX = {
  minWidth: "90px",
  height: "32px",
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "none" as const,
} as const;

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  backgroundColor: string;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  onClick,
  backgroundColor,
  disabled = false
}) => {
  return (
    <Button
      variant="contained"
      size="small"
      onClick={onClick}
      sx={{
        ...ACTION_BUTTON_SX,
        backgroundColor,
      }}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default ActionButton;